module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "scrollable": "",
      "width": "800px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "custom-card-title"
  }, [_vm._v("\n        Platforms\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "bg-white",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('inf-platform-data-table', {
    attrs: {
      "items": _vm.platforms,
      "influencerID": _vm.influencerID
    },
    on: {
      "showCompareModal": _vm.showCompareModal,
      "reload": _vm.reloadPage,
      "close": _vm.close
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.compareDefaultInf) ? _c('comparison-modal', {
    attrs: {
      "influencer": _vm.compareDefaultInf,
      "compareInf": _vm.compareInf
    },
    on: {
      "mergeSuccess": _vm.mergeSuccess
    },
    model: {
      value: (_vm.comparisonDialog),
      callback: function($$v) {
        _vm.comparisonDialog = $$v
      },
      expression: "comparisonDialog"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-186b5b12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/InfPlatforms/ViewModal.vue
// module id = 2016
// module chunks = 0